export const SENDOTP_INIT_ACTION = "SENDOTP_INIT";
export const SENDOTP_SUCCESS_ACTION = SENDOTP_INIT_ACTION + "_SUCCESS";
export const SENDOTP_FAIL_ACTION = SENDOTP_INIT_ACTION + "_FAIL";

export function SendOTP(value) {
  return {
    type: SENDOTP_INIT_ACTION,
  };
}
